import type { Appointment } from './types';

const MONEY_TOLERANCE = 0.005;

export interface ReservationFeeState {
  configured: boolean;
  amount: number;
  paid: number;
  balance: number;
  isPaid: boolean;
  status: 'pending' | 'paid' | 'waived' | 'refunded';
}

export const isNewPatientStatus = (status: string | number | null | undefined) =>
  status === 'New' || status === 0;

export const getReservationFeeState = (appointment: Appointment): ReservationFeeState => {
  if (appointment.reservationFee) {
    const fee = appointment.reservationFee;
    return {
      configured: true,
      amount: Math.max(0, fee.amount),
      paid: Math.max(0, fee.paidAmount),
      balance: Math.max(0, fee.balance),
      isPaid: fee.status === 'paid' || fee.status === 'waived',
      status: fee.status
    };
  }
  const configured = typeof appointment.reservationFeeAmount === 'number';
  const amount = configured ? Math.max(0, appointment.reservationFeeAmount!) : 0;
  const paid = Math.max(0, (appointment.payments || []).reduce(
    (sum, payment) => sum + (payment.kind === 'refund' ? -payment.amount : payment.amount),
    0
  ));
  const balance = configured ? Math.max(0, amount - paid) : 0;
  const refunded = (appointment.payments || []).some(payment => payment.kind === 'refund');
  const status = amount <= MONEY_TOLERANCE
    ? 'waived'
    : paid <= MONEY_TOLERANCE && refunded
      ? 'refunded'
      : configured && balance <= MONEY_TOLERANCE
        ? 'paid'
        : 'pending';

  return {
    configured,
    amount,
    paid,
    balance,
    isPaid: configured && balance <= MONEY_TOLERANCE,
    status
  };
};
